export default {
  props: ['content', 'title'],
  data() {
    return {
      knowMoreSettings: {
        btn: {
          style: {
            color : '#2c3b48',
            width : 180
          }
        },
        isLoading : false,
        snackbar  : {
          isSnackbarOpen : false,
          color          : '',
          message        : ''
        }
      }
    };
  },
  methods: {
    openLinkGroupItem(item) {
      if (item.type === 'library') {
        window.open(`lti-launch/?type=library&id=${item.id}`, '_blank');
      } else {
        window.open(item.url, '_blank');
      }
    }
  }
};
